import type { MarketMakerRequestStatusEnumType } from '@forgd/shared/enums'
import { MarketMakerRequestStatusEnum as S } from '@forgd/shared/enums'

export type RfqTabState = 'disabled' | 'locked' | 'unlocked' | 'completed'

const STATUS_ORDER: MarketMakerRequestStatusEnumType[] = [
  S.RoundOneWaitingForQuotes,
  S.RoundOneQuotesInReview,
  S.RoundOneQuotesAccepted,
  S.RoundTwoWaitingForQuotes,
  S.RoundTwoQuotesInReview,
  S.RoundTwoQuotesAccepted,
]

function isAtLeast(current: MarketMakerRequestStatusEnumType | undefined, target: MarketMakerRequestStatusEnumType): boolean {
  const currentIndex = current ? STATUS_ORDER.indexOf(current) : -1
  return currentIndex >= STATUS_ORDER.indexOf(target)
}

export function getQuoteTabState(
  status: MarketMakerRequestStatusEnumType | undefined,
  waitingStatus: MarketMakerRequestStatusEnumType,
  reviewStatus: MarketMakerRequestStatusEnumType,
  round: number,
  isReopenedForMe?: boolean,
  currentRound?: number,
): RfqTabState {
  if (status === waitingStatus) {
    return 'unlocked'
  }
  if (status === reviewStatus && isReopenedForMe && currentRound === round) {
    return 'unlocked'
  }
  if (isAtLeast(status, reviewStatus)) {
    return 'completed'
  }
  if (isAtLeast(status, waitingStatus)) {
    return 'locked'
  }
  return 'disabled'
}

export function getOutcomeTabState(
  status: MarketMakerRequestStatusEnumType | undefined,
  acceptedStatus: MarketMakerRequestStatusEnumType,
  waitingStatus: MarketMakerRequestStatusEnumType,
): RfqTabState {
  if (isAtLeast(status, acceptedStatus)) {
    return 'completed'
  }
  if (isAtLeast(status, waitingStatus)) {
    return 'locked'
  }
  return 'disabled'
}
